<template>
	<div class="empower">
		<div class="empower_top">
			<div class="empower_title">企业专利授权量</div>
            <div class="powerList">
                <div class="powerItem" v-for="(item,index) in powerList" :key="index">
                    <div class="title">{{item.title}}</div>
                    <div class="piece">
                        <countTo :startVal='0' :endVal='Number(item.piece)' :duration='800' />件
                    </div>
                    <el-progress type="circle" class="circle" :percentage="Number(item.zhanbi)" :width="70"></el-progress>
                </div>
            </div>
		</div>
		<div class="empower_bottom">
			<div class="empower_title">企业发明专利有效量</div>
            <div class="effectList">
                <div class="effectItem" v-for="(item,index) in effectList" :key="index">
                    <div class="title">{{item.title}}</div>
                    <div class="many">
                        <countTo  :startVal='0' :endVal='Number(item.piece)' :duration='800'/>{{item.unit}}
                    </div>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
    export default {
        data(){
            return{
                powerList:[],
                effectList:[],
            }
        },
		methods:{
			getData(data){
				this.powerList = [
                    {
                        title:'发明专利',
                        piece:data.zl_qy_fmshouq,
                        zhanbi:data.zl_qy_fmshouq_bfb,
                    }, {
                        title:'实用新型',
                        piece:data.zl_qy_sxshouq,
                        zhanbi:data.zl_qy_sxshouq_bfb,
                    }, {
                        title:'外观设计',
                        piece:data.zl_qy_wgshouq,
                        zhanbi:data.zl_qy_wgshouq_bfb,
                    },
                ]
				this.effectList = [
                    {
                        title:'企业数',
                        piece:data.zl_qy_fmyoux_qy,
						unit:'家',
                    },{
                        title:'发明有效量',
                        piece:data.zl_qy_fmyoux,
						unit:'件',
                    },
                ]
			},
		}
    }
</script>

<style >
	.el-progress__text{
		color:#fff !important;
		font-size:14px !important;
	}
</style>